module.exports = __webpack_public_path__ + "media/images/icon/i-population-cd69822ae63dddac814a61d6f15a2dbf.svg";